import {createGate} from "effector-react";

export const CertsListGate = createGate()
export const SelectedCertGate = createGate()
export const SelectedCertSupplierGate = createGate()